<template>
  <div>
    <b-modal
      ref="noStockModal"
      title="Out of Stock"
      ok-title="Submit"
      @ok="submitRequest"
    >
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Model</th>
            <th>Days</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(item, index) of items">
            <td>{{ item.model }}</td>
            <td>
              <div class="form-group">
                <select
                  class="form-control"
                  id="days"
                  name="days"
                  required
                  v-model="item.days"
                >
                  <option value="0">In Stock</option>
                  <option value="7">7</option>
                  <option value="14">14</option>
                  <option value="28">28</option>
                </select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "nostock-modal",
  props: ["items"],
  data() {
    return {};
  },
  mounted: function() {},
  methods: {
    showModal() {
      this.$refs.noStockModal.show();
      console.log(this.items);
    },
    submitRequest() {
      this.$emit("outOfStockModalSubmit", this.items);
    }
  }
};
</script>
